// Utility for generating RFC4122 v4 UUIDs with a secure fallback.
// Prefers crypto.randomUUID() when available.

export function generateUuid(): string {
  // Prefer the Web Crypto API if present
  try {
    const globalCrypto = (globalThis as any)?.crypto;
    if (globalCrypto?.randomUUID && typeof globalCrypto.randomUUID === 'function') {
      return globalCrypto.randomUUID();
    }

    const getRandomBytes = (length: number): number[] => {
      if (globalCrypto?.getRandomValues && typeof globalCrypto.getRandomValues === 'function') {
        const arr = new Uint8Array(length);
        globalCrypto.getRandomValues(arr);
        return Array.from(arr);
      }
      // Non-crypto fallback
      return Array.from({length}, () => Math.floor(Math.random() * 256));
    };

    const bytes = getRandomBytes(16);
    // Per RFC4122 section 4.4
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10xx

    const toHex = (b: number) => b.toString(16).padStart(2, '0');
    const hex = bytes.map(toHex).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  } catch {
    // Final non-crypto fallback
    const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
  }
}


